import React from 'react';

export const BeneficiaryTOD = ({ isIndividual, isJoint }) => {
  return (
    <div className="b-padding--organism-jumbo">
      <div className="b-typography-serif--headline--200 b-font-weight-bold b-margin--micro--normal beacon-on-lighter">
        {"Important information about updating your beneficiaries"}
      </div>
      {isIndividual && (
        <div className="b-typography-sans-serif--body--200 b-font-weight-light b-margin--micro--normal">
          <p>
            {`Adding one or more beneficiaries to the Individual account will designate it as a Transfer on Death (TOD) account.`}
          </p>
          <br />
          <p>
            {`A TOD arrangement is a simplified estate planning method to designate beneficiaries to receive your assets upon your death without going through the probate process. T. Rowe Price TOD accounts are governed by the Maryland Uniform Transfer on Death Security Registration Act.`}
          </p>
          <br />
          <p>
            {`Please keep in mind that a TOD is only for accounts owned by one individual or by joint owners with rights of survivorship. An owner or joint owner of the account may not be listed as a beneficiary, and your estate may not be designated as a beneficiary.`}
          </p>
        </div>
      )}
      {isJoint && (
        <div className="b-typography-sans-serif--body--200 b-font-weight-light b-margin--micro--normal">
          <p>
            {`Adding one or more beneficiaries to the Joint Tenant account will designate it as a Transfer on Death (TOD) account.`}
          </p>
          <br />
          <p>
            {`A TOD arrangement is a simplified estate planning method to designate beneficiaries to receive your assets upon your death without going through the probate process. T. Rowe Price TOD accounts are governed by the Maryland Uniform Transfer on Death Security Registration Act.`}
          </p>
          <br />
          <p>
            {`Please keep in mind that a TOD is only for accounts owned by one individual or by joint owners with rights of survivorship. An owner or joint owner of the account may not be listed as a beneficiary, and your estate may not be designated as a beneficiary.`}
          </p>
        </div>
      )}
    </div>
  );
}
